export default class OverscrollController {
  constructor(scrollContainer, scrollContent) {
    this.scrollContainer = scrollContainer;
    this.scrollContent = scrollContent;
    if (!this.scrollContainer || !this.scrollContent) return;

    this.init();
  }

  init() {
    this.setupStyle();
    this.bindEvent();
  }

  setupStyle() {
    this.scrollContainer.style.overscrollBehavior = "none";

    const contentHeight = this.scrollContent.getBoundingClientRect().height;
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight;

    if (contentHeight <= viewportHeight) {
      this.scrollContent.style.height = "calc(100dvh + 1px)";
    }
  }

  bindEvent() {
    window.addEventListener("resize", () => this.setupStyle());
  }
}
